import { getProjectsTour } from '@/domain/project-tour/actions/get-projects-tour.action';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

export const deleteProjectTour = createAppAsyncThunk(
  'projectTour/deleteProjectTour',
  async (
    id: number,
    { extra: { projectTourGateway, snackbarGateway }, dispatch },
  ): Promise<void> => {
    try {
      await projectTourGateway.delete(id);
      showSnackbarSuccess(snackbarGateway);
      dispatch(getProjectsTour());
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('DeleteProject.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('DeleteProject.Message.error'));
}
